import { GET_WHATSAPP_NOTIFICATION_SUCCESS, GET_WHATSAPP_NOTIFICATION_REQUEST, GET_WHATSAPP_NOTIFICATION_FAILURE, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getWhatsappNotificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_WHATSAPP_NOTIFICATION_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_WHATSAPP_NOTIFICATION_REQUEST:
            return Object.assign({}, state);
        case GET_WHATSAPP_NOTIFICATION_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default getWhatsappNotificationReducer;
